var loginMessage = "";


export function getLoginMessage(){
    return loginMessage;
}

export function setLoginMessage(message){
    loginMessage = message;
}